import classNames from 'classnames'
import React from 'react'

export const FreeButton = (props: any) => {
  const { className } = props
  const inputClass = classNames(`hover:bg-[#5D78F9]  ${className}`)
  return <button {...props} className={inputClass}></button>
}
